import SuccessIcon from "../../../../assets/images/assessment-success.svg";
import FailIcon from "../../../../assets/images/assessment-fail.svg";
import CheckIcon from "../../../../assets/images/assessment-check.svg";
import CrossIcon from "../../../../assets/images/assessment-x.svg";

import Modal from "../../../modal/Modal";

// import { PASSING_MARKS } from "./constant";

import styles from "./styles.module.scss";
import { RETAKE_VIEW } from "../../../../utils/cookiesmanager";

const ModuleStatusComponent = (props) => {
  const { show, marks , handleContinue , handleTryAgain , passingMarks = 50 } = props;
  
  const isAttemptIsRetake = localStorage.getItem(RETAKE_VIEW) && marks?.percentage <= passingMarks

  return (
    <>
      <Modal visible={show}>
        <div className={styles["assessment-wrapper"]}>
          {marks?.percentage >= passingMarks ? (
            <div className={styles["success-image"]}>
              <img src={SuccessIcon} alt="success" />
            </div>
          ) : (
            <div className={styles["success-image"]}>
              <img src={FailIcon} alt="fail" />
            </div>
          )}
          {marks?.percentage >= passingMarks ? (
            <div className={styles.title}>Congratulations</div>
          ) : (
            <div className={styles.title}>Try again!</div>
          )}

          <div className={styles.description}>
            You have completed module 1: Introduction of Inclusive. you score
            <span
              className={`${styles["numeric-result"]} ${
                marks?.percentage < passingMarks ? styles["low-score"] : ""
              }`}
            >
              {" "}
              {`${marks?.percentage}%`}
            </span>
          </div>
          <div className={styles["result-wrapper"]}>
            {marks?.result?.map((item, index) => (
              <div className={styles.result} key={item.id}>
                {item?.isCorrect === 1 ? (
                  <div className={styles["result-check"]}>
                    <img src={CheckIcon} alt="check" />
                  </div>
                ) : (
                  <div className={styles["result-cross"]}>
                    <img src={CrossIcon} alt="cross" />
                  </div>
                )}

                <div>Question {index + 1}</div>
              </div>
            ))}
          </div>

          {marks?.percentage >= passingMarks ? (
            <div className={styles["button-wrapper"]}>
              <button className={styles.button} onClick={handleContinue}>Continue</button>
            </div>
          ) : (
            isAttemptIsRetake
            ?
            null
            :
            <div className={styles["button-wrapper"]}>
              <button className={styles.button} onClick={handleTryAgain}>Try again!</button>
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default ModuleStatusComponent;
